import Swiper, { Navigation, Pagination } from "swiper";

export default class ComponentListagemPacotesPassagens {
    constructor() {
        this.sliders = document.querySelectorAll('.swiper--component-listagem_pacotes_passagens');
        this.prevButtons = document.querySelectorAll('.slider-button-prev--component-listagem_pacotes_passagens');
        this.nextButtons = document.querySelectorAll('.slider-button-next--component-listagem_pacotes_passagens');
        this.paginations = document.querySelectorAll('.slider-pagination--component-listagem_pacotes_passagens');

        this.btnHospedagem = document.querySelector('.btn-hospedagem');
        this.btnPacotesAereos = document.querySelector('.btn-pacotes-aereos');

        this.pacotesContainer = document.querySelector('.pacotes-container');
        this.passagensContainer = document.querySelector('.passagens-container');

        this.init();
    }

    init() {
        this.initSliders();
        this.initTabs();
        this.truncateTitles();
    }

    initSliders() {
        this.sliders.forEach((slider, index) => {
            new Swiper(slider, {
                modules: [Navigation, Pagination],
                grabCursor: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: this.nextButtons[index],
                    prevEl: this.prevButtons[index],
                },
                pagination: {
                    el: this.paginations[index],
                    clickable: true,
                    type: "fraction",
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1.3,
                        spaceBetween: 22,
                        slidesOffsetBefore: 22,
                        slidesOffsetAfter: 22,
                    },
                    768: {
                        slidesPerView: 3.2,
                        spaceBetween: 30,
                    },
                    1024: {
                        slidesPerView: 2.99,
                        spaceBetween: 30,
                        slidesOffsetAfter: 130,
                    },
                    1600: {
                        slidesPerView: 4.7,
                        spaceBetween: 30,
                        slidesOffsetAfter: 400,
                    },
                },
            });
        });
    }

    initTabs() {
        if (!this.btnHospedagem || !this.btnPacotesAereos) return;

        this.btnHospedagem.addEventListener('click', () => {
            this.toggleTab('hospedagem');
        });

        this.btnPacotesAereos.addEventListener('click', () => {
            this.toggleTab('pacotes');
        });

        if (window.innerWidth < 1024) {
            this.toggleTab('hospedagem');
        } else{
            this.pacotesContainer?.classList.add('active');
            this.passagensContainer?.classList.add('active');
        }
    }

    toggleTab(tab) {
        const activeClass = 'active-tab';
        const isDesktop = window.innerWidth >= 1024;
    
        const isHospedagemActive = this.btnHospedagem?.classList.contains(activeClass);
        const isPacotesActive = this.btnPacotesAereos?.classList.contains(activeClass);

        if(!isDesktop){
            if (tab === 'hospedagem') {
                this.pacotesContainer?.classList.add('active');
                this.passagensContainer?.classList.remove('active');
                this.btnHospedagem?.classList.add(activeClass);
                this.btnPacotesAereos?.classList.remove(activeClass);
            } else if (tab === 'pacotes') {
                this.pacotesContainer?.classList.remove('active');
                this.passagensContainer?.classList.add('active');
                this.btnHospedagem?.classList.remove(activeClass);
                this.btnPacotesAereos?.classList.add(activeClass);
            }
        } else if(isDesktop ){
            if (tab === 'hospedagem') {
                if (isHospedagemActive) {
                    this.pacotesContainer?.classList.remove('active');
                    this.passagensContainer?.classList.remove('active');
                    this.btnHospedagem?.classList.remove(activeClass);
                    this.pacotesContainer?.classList.add('active');
                    this.passagensContainer?.classList.add('active');
                } else {
                    this.pacotesContainer?.classList.add('active');
                    this.passagensContainer?.classList.remove('active');
                    this.btnHospedagem?.classList.add(activeClass);
                    this.btnPacotesAereos?.classList.remove(activeClass);
                }
            } else if (tab === 'pacotes') {
                if (isPacotesActive) {
                    this.pacotesContainer?.classList.remove('active');
                    this.passagensContainer?.classList.remove('active');
                    this.btnPacotesAereos?.classList.remove(activeClass);
                    this.pacotesContainer?.classList.add('active');
                    this.passagensContainer?.classList.add('active');
                } else {
                    this.pacotesContainer?.classList.remove('active');
                    this.passagensContainer?.classList.add('active');
                    this.btnHospedagem?.classList.remove(activeClass);
                    this.btnPacotesAereos?.classList.add(activeClass);
                }
            }
        }
    }
    
    truncateTitles() {
        const titles = document.querySelectorAll(".promo--item h3");
        titles.forEach(title => {
            const text = title.textContent;
            if (text.length > 65) {
                title.textContent = text.slice(0, 65) + '...';
            }
        });
    }
}